import axios from "axios";

export const getGeoLocationApi = async(address) => {
    try {
        const res = await axios.get('https://nominatim.openstreetmap.org/search', {
            params: {
                q: `${address}, Maroc`,
                format: 'json',
                limit: 1
            }
        })
        return res.data
    }
    catch(err) {
        console.log(err)
        throw err
    }
}
